module.exports = __webpack_public_path__ + "img/cardiovascular.f947e146.png";